module.exports = "/assets/fe8c41bf044f420ed30442cdab26542e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/KR.png
// module id = 1555
// module chunks = 0